import { createContext, useContext } from 'react';
import type { Client } from '../../api/client.js';

/**
 * Client HTTP des espaces externes. La coquille ne fournit pas encore le sien aux écrans (RFC-L60-01) : tant
 * qu’elle ne l’enveloppe pas dans ce fournisseur, les écrans construisent un client sur le `fetch` du navigateur.
 */
export const ContexteClientExterne = createContext<Client | null>(null);
export const FournisseurClientExterne = ContexteClientExterne.Provider;
export const useClientExterne = (): Client | null => useContext(ContexteClientExterne);
